// Fonds de carte. Aucune source ne fournit mieux que le niveau 19 à La Réunion et Mayotte :
// au-delà (jusqu'à MAX_ZOOM), Leaflet agrandit les tuiles du niveau natif (maxNativeZoom),
// ce qui permet de poser les points d'un tracé plus finement.
export const MAX_ZOOM = 21;

// Photo aérienne IGN (Géoplateforme, service public sans clé) : plus nette que l'image ESRI.
export const IGN_ORTHO_URL =
  "https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ORTHOIMAGERY.ORTHOPHOTOS" +
  "&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/jpeg&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}";

export const TILE_LAYERS = {
  sentinel2: { name: "Sentinel-2", url: "https://tiles.maps.eox.at/wmts/1.0.0/s2cloudless-2021_3857/default/GoogleMapsCompatible/{z}/{y}/{x}.jpg", attribution: "Sentinel-2 (EOX/ESA)", maxNativeZoom: 17 },
  esri: { name: "Satellite HD", url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", attribution: "ESRI", maxNativeZoom: 19 },
  ign: { name: "Photo aérienne IGN", url: IGN_ORTHO_URL, attribution: "IGN-F / Géoplateforme", maxNativeZoom: 19 },
  osm: { name: "Carte", url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: "OSM", maxNativeZoom: 19 },
};

// Fond des outils de tracé (saisie, îlots, recalage) : la photo IGN, la plus précise
export const DRAW_LAYER = TILE_LAYERS.ign;
